import { Link } from "@mui/material";
import { ItemProperty, MaterialSymbolIcon, MaterialSymbols } from "src/components";
import { FormRecipientType, Links } from "src/constants";
import type { FormSubmissionDetailDto } from "src/http";

interface Props {
  formSubmission: FormSubmissionDetailDto;
}

const FormSubmissionCreatorProperty = (props: Props) => {
  return (
    <ItemProperty
      labelIcon={<MaterialSymbolIcon symbol={MaterialSymbols.PersonEdit} />}
      label={props.formSubmission.recipientType === FormRecipientType.Self ? "Creator" : "Sender"}
    >
      <Link href={Links.User(props.formSubmission.createdByUser.userId)}>
        {props.formSubmission.createdByUser.displayName}
      </Link>
    </ItemProperty>
  );
};

export { FormSubmissionCreatorProperty };
